$(document).ready(function(){
  $('.footer-blocks .footer-block:nth-of-type(4)').css('--desktop-width', '15%');
});

document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll('.product__selectors .selector-wrapper[data-option-position="2"] .radio__label')
    .forEach(function (el) {
      // 한 번만 처리되도록 이미 <br>가 없다면만 치환
      if (!el.innerHTML.includes('<br')) {
        el.innerHTML = el.textContent.replace(/\s*\/\s*/, '/<br>');
      }
    });
});